import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import axios from "axios";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../../context/auth";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import BASEURL from "../../Utils/Baseurl";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TaxTableForm from "./TaxTableForm";
import MaterialSelect from "../../../components/MasterSelect";

const { v4: uuidv4 } = require("uuid"); // Usedn ro generate uuid\

const slabOptions = [
  { value: "NEW_TAX_REGIME", label: "New Tax Regime" },
  { value: "OLD_TAX_REGIME", label: "Old Tax Regime" },
];

const AddTax = () => {
  const { taxView, setTaxView, taxEdit, setTaxEdit, AccessData } =
    useUserDetails();
  const location = useLocation();
  const navigate = useNavigate();

  const taxDetails = location.state || [];
  const queryParams = new URLSearchParams(window.location.search);
  const ids = queryParams.get("id");
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  // const {AccessData} = useUserDetails();
  const [structureData, setStructureData] = useState({
    slabName: "",
    slabNameStatus: "",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [tax, setTax] = useState([
    {
      id: uuidv4(),
      fromAmount: "0",
      toAmount: "",
      percentage: "",
      taxableAmount: "",
      tax: "",
    },
    {
      id: uuidv4(),
      fromAmount: "",
      toAmount: "",
      percentage: "",
      taxableAmount: "",
      tax: "",
      isLast: true, // open-ended last row
    },
  ]);

  const [orginaltax, setOrginaltax] = useState([]);

  useEffect(() => {
    const editId = ids?.split("-")[0];
    if (editId) {
      getdata(editId);
      setTaxView(true);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
      setTaxView(false);
    }
  }, []);

  useEffect(() => {
    if (structureData?.slabName.value && taxDetails?.length > 0) {
      const selectedSlab = taxDetails.find(
        (item) => item.slabName === structureData.slabName.value
      );

      console.log("selectedSlab", selectedSlab);

      if (selectedSlab) {
        getdata(selectedSlab.id, true);
        setTaxEdit(true);
      } else {
        setTax([
          {
            id: uuidv4(),
            fromAmount: "0",
            toAmount: "",
            percentage: "",
            taxableAmount: "",
            tax: "",
          },
          {
            id: uuidv4(),
            fromAmount: "",
            toAmount: "",
            percentage: "",
            taxableAmount: "",
            tax: "",
            isLast: true,
          },
        ]);
        setTaxEdit(false); // optionally make editable false if not found
      }
    }
  }, [structureData?.slabName?.value]);

  const AddDeleteComponent = (id) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your component.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleDeleteRow(id);
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDeleteRow = (id) => {
    setTax((prevData) => {
      const indexToDelete = prevData.findIndex((item) => item.id === id);
      if (indexToDelete === -1) return prevData;

      const updated = [...prevData];
      const deletedItem = updated[indexToDelete];

      const prevRow = updated[indexToDelete - 1];
      const nextRow = updated[indexToDelete + 1];

      // Remove the row
      updated.splice(indexToDelete, 1);

      // If there's a next row after the deleted row
      if (nextRow) {
        const prevToAmount = prevRow ? parseInt(prevRow.toAmount, 10) : null;
        if (!isNaN(prevToAmount)) {
          nextRow.fromAmount = String(prevToAmount + 1);
        }
      }

      return updated;
    });
  };

  const onAddTax = () => {
    setTax((prevTax) => {
      const taxCopy = [...prevTax];
      const lastIndex = taxCopy.findIndex((row) => row.isLast);
      const lastEditableRow = taxCopy[lastIndex - 1];

      const newFromAmount = lastEditableRow.toAmount
        ? String(parseInt(lastEditableRow.toAmount, 10) + 1)
        : ""; // leave empty if toAmount is empty

      const newRow = {
        id: uuidv4(),
        fromAmount: newFromAmount,
        toAmount: "",
        percentage: "",
        taxableAmount: "",
        tax: "",
        isLast: false,
      };

      taxCopy.splice(lastIndex, 0, newRow);

      // Reset last row's fromAmount to empty (will be recalculated later)
      taxCopy[taxCopy.length - 1].fromAmount = "";

      return taxCopy;
    });
  };

  const onDataChange = (field, value, id) => {
    setTax((prevData) => {
      const updated = prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      );

      // Update dependent fields for the changed row
      const rowIndex = updated.findIndex((item) => item.id === id);
      const row = updated[rowIndex];

      if (!row.isLast) {
        const from = parseInt(row.fromAmount, 10);
        const to = parseInt(row.toAmount, 10);
        const percent = parseFloat(row.percentage);

        // Taxable amount
        if (!isNaN(from) && !isNaN(to) && to >= from) {
          if (rowIndex === 0) {
            row.taxableAmount = (to - from).toString(); // first row: no +1
          } else {
            row.taxableAmount = (to - from + 1).toString(); // others: add +1
          }
        } else {
          row.taxableAmount = "";
        }

        // Tax
        const taxable = parseInt(row.taxableAmount, 10);
        if (!isNaN(taxable) && !isNaN(percent)) {
          row.tax = ((taxable * percent) / 100).toFixed(2);
        } else {
          row.tax = "";
        }

        // Update last row's fromAmount if this is the last editable row
        if (field === "toAmount") {
          const nextRow = updated[rowIndex + 1];

          if (nextRow && !nextRow.isLast) {
            if (!isNaN(to)) {
              nextRow.fromAmount = String(to + 1);
            } else {
              nextRow.fromAmount = "";
            }
          }

          // Also update the last row if it's the next one
          if (updated[rowIndex + 1]?.isLast) {
            if (!isNaN(to)) {
              updated[rowIndex + 1].fromAmount = String(to + 1);
            } else {
              updated[rowIndex + 1].fromAmount = "";
            }
          }
        }
      } else {
        // Last row: only percentage is editable
        const percent = parseFloat(row.percentage);
        if (!isNaN(percent)) {
          row.taxableAmount = "∞";
          row.tax = "∞";
        } else {
          row.taxableAmount = "";
          row.tax = "";
        }
      }

      return [...updated];
    });
  };

  const handleStructureDataChange = (event, selectEvent) => {
    let structureState = { ...structureData };

    // Handle Select inputs (like slabName, payrollFrequency)
    if (!event?.target && selectEvent?.name) {
      const { name } = selectEvent;
      const label = event?.label || "";
      const value = event;

      const validText = /^[A-Za-z0-9 ]+$/.test(label);

      structureState[name] = value;
      structureState[`${name}Status`] =
        label === "" ? "unchecked" : validText ? "success" : "error";
    }

    // Handle TextField or other native inputs (like structureName)
    if (event?.target) {
      const { name, value } = event.target;

      switch (name) {
        case "structureName":
          {
            const valid = /^([a-zA-Z ]{1,20})$/.test(value);
            structureState[`${name}Status`] =
              value === "" ? "unchecked" : valid ? "success" : "error";
          }
          break;
        default:
          break;
      }

      structureState[name] = value;
    }

    setStructureData({ ...structureState });
  };

  const handleAddComponent = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onComponentSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTaxEdit(true);
    setTaxView(false);
  };

  const checkAllFields = () => {
    // Check slab name
    const isSlabNameValid = structureData?.slabNameStatus === "success";

    // Validate only non-last tax rows
    const areTaxRowsValid = tax
      .filter((item) => !item.isLast) // exclude last row
      .every((item) => {
        const from = String(item?.fromAmount ?? "").trim();
        const to = String(item?.toAmount ?? "").trim();
        const percentage = String(item?.percentage ?? "").trim();

        const isFromValid = from !== "" && !isNaN(from);
        const isToValid = to !== "" && !isNaN(to);
        const isPercentageValid =
          percentage !== "" &&
          !isNaN(percentage) &&
          parseFloat(percentage) <= 100;

        return isFromValid && isToValid && isPercentageValid;
      });

    return isSlabNameValid && areTaxRowsValid;
  };

  const onDiscardTax = () => {
    if (orginaltax.length > 0) {
      const restored = JSON.parse(JSON.stringify(orginaltax));

      // Ensure last row has isLast: true
      restored.forEach((item, index) => {
        item.isLast = index === restored.length - 1;
      });

      setTax(restored);
    }
    setTaxEdit(true);
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCancelAction = () => {
    navigate("/tax");
  };

  const getdata = async (id, add) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query GetTaxById ($id: ID!){ 

  taxConfiguration(id: $id){ 

    success 

    message 

    data { 

      id 

      slabName 

      slabs { 

        order 

        fromAmount 

        toAmount 

        percentage 

      } 

    } 

  } 

} `;

    try {
      const variables = { id };

      // Make the Axios POST request to the GraphQL API
      const response = await axios.post(BASEURL, {
        query,
        variables,
      });

      const alldata = response.data.data.taxConfiguration.data;

      const transformedTax = alldata.slabs.map((item, index) => {
        const from = parseFloat(item.fromAmount ?? "0") || 0;
        const to = parseFloat(item.toAmount ?? "0") || 0;
        const percentage = parseFloat(item.percentage ?? "0") || 0;

        const isLast = item.toAmount === null;

        const taxableAmount = isLast
          ? ""
          : index !== 0
          ? to - from + 1
          : to - from;
        const tax = isLast
          ? ""
          : (taxableAmount * (percentage / 100)).toFixed(2);

        return {
          id: uuidv4(),
          fromAmount: parseInt(parseFloat(item.fromAmount)) || "0",
          toAmount: parseInt(parseFloat(item.toAmount)) ?? "",
          percentage: item.percentage ?? "",
          taxableAmount,
          tax,
          isLast,
        };
      });

      setTax(transformedTax);

      setOrginaltax(JSON.parse(JSON.stringify(transformedTax)));
      console.log("add--->", add);
      if (!add) {
        setStructureData({
          slabName: {
            label:
              alldata.slabName === "NEW_TAX_REGIME"
                ? "New Tax Regime"
                : "Old Tax Regime",
            value:
              alldata.slabName === "NEW_TAX_REGIME"
                ? "New Tax Regime"
                : "Old Tax Regime",
          },
          slabNameStatus: "success",
        });
      }

      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onComponentSubmit = async () => {
    const inputPayload = {
      input: {
        slabName: structureData.slabName.label || "",
        slabs: tax.map((item) => ({
          toAmount: item.toAmount ? Number(item.toAmount) : null,
          percentage: Number(item.percentage),
        })),
      },
    };
    const mutation = `
  mutation CreateOrUpdateTax($input: TaxConfigurationInput!) {
    createOrUpdateTaxConfiguration(input: $input) {
      success
      message
      taxConfiguration {
        id
        slabName
        slabs {
          order
          fromAmount
          toAmount
          percentage
        }
      }
    }
  }
`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: mutation,
          variables: inputPayload,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data?.data?.createOrUpdateTaxConfiguration;

      if (result?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Tax Submit Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/tax");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: result?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Request failed:", error.message);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the salary structure details for
                    you. This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card sx={{ overflow: "visible" }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                {!taxView && (
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Tax Details
                    </MaterialTypography>
                  </Stack>
                )}
                {taxView && (
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Tax Details
                    </MaterialTypography>
                  </Stack>
                )}
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) => item.component === "EditTax" && item.can_access
                  ) && (
                    <ButtonGroup variant="outlined" aria-label="button group">
                      {(taxView || taxEdit) && ids !== null && (
                        <>
                          <ButtonGroup
                            variant="outlined"
                            aria-label="Loading button group"
                          >
                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={toggleEdit}
                              startIcon={<EditIcon />}
                            >
                              Edit
                            </MaterialButton>
                          </ButtonGroup>
                        </>
                      )}
                    </ButtonGroup>
                  )}
              </Stack>
            }
          />
          <CardContent sx={{ minHeight: "60vh" }}>
            <MaterialBox>
              <Grid container spacing={1}>
                <Grid size={{ xs: 5, sm: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Slab Name <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="slabName"
                    value={structureData.slabName}
                    onChange={handleStructureDataChange}
                    options={slabOptions}
                    menuPlacement="auto"
                    label="Select Slab"
                    customStyles={{ paddingDisabled: true }}
                    isDisabled={taxView === true || ids !== null}
                  />
                </Grid>
              </Grid>
            </MaterialBox>
            <MaterialBox>
              <MaterialTypography
                sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Taxable Salary Slabs
              </MaterialTypography>
              <TaxTableForm
                tableData={tax}
                confirmDelete={AddDeleteComponent}
                onAddRow={onAddTax}
                onDataChange={onDataChange}
                taxEdit={taxEdit}
                taxView={taxView}
                pageState={pageState}
                type="tax"
              />
              <MaterialButton
                variant="gradient"
                color="dark"
                disabled={taxView === true || !checkAllFields() ? true : false}
                startIcon={<Add />}
                onClick={() => {
                  onAddTax();
                }}
                mb={0}
                pb={0}
              >
                Add
              </MaterialButton>
            </MaterialBox>
          </CardContent>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {taxView === false && taxEdit === false && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddComponent}
                >
                  submit
                </MaterialButton>
              </>
            )}

            {taxEdit && taxView === false && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={onDiscardTax}
                >
                  Discard
                </MaterialButton>

                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddComponent}
                >
                  Update
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddTax;
